<script>
  import Dropzone from 'dropzone'
  import axios from 'axios'
  import api from '../api'
  import Promise from 'bluebird'

  Dropzone.autoDiscover = false

  export default {
    props: ['address'],

    mounted () {
      let dropzoneOptions = {
        method: 'PUT',
        url: '/',
        parallelUploads: 1,
        timeout: 300000,

        sending (file, xhr) {
          let _send = xhr.send
          xhr.send = () => {
            _send.call(xhr, file)
          }
        },

        accept: async (file, done) => {
          try {
            let response = await axios.post(process.env.MIX_SIGN_URL, { filePath: file.name, contentType: file.type })
            file.uploadURL = response.data.url
            done()
          }
          catch (err) {
            console.error(err)
            done(err)
          }
        }
      }

      this.dropzone = new Dropzone(this.$el, dropzoneOptions)

      this.dropzone.on('processing', file => {
        this.dropzone.options.url = file.uploadURL
      })

      this.dropzone.on('success', async (file) => {
        // give AWS some time to register the file otherwise we try and load
        // it too quickly
        await Promise.delay(1000)
        
        let response = await api.apios.post('/api/address_photos', {
          address_id: this.address.id,
          path: file.name
        })

        this.$emit('refresh')
      })
    }
  }
</script>
<style>
  @import '~dropzone/dist/dropzone.css';
</style>
<template>
  <form class="box dropzone"></form>
</template>